import { KeyboardArrowDown } from '@material-ui/icons'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import { toAbsoluteUrl } from '../../../../../../../../../Utils/_helpers'
import FiltersExpandCollapseButton from '../../../FiltersExpandCollapseButton'

class Toggle extends PureComponent {
  static propTypes = {
    expanded: PropTypes.bool,
    isLeaf: PropTypes.bool,
    onNodeToggle: PropTypes.func,
    id: PropTypes.string,
    viewMode: PropTypes.string
  }

  onToggle = e => {
    e.stopPropagation()
    e.nativeEvent.stopImmediatePropagation()
    this.props.onNodeToggle(this.props.id)
  }

  onKeyDown = e => {
    if (e.key === 'Enter' || e.keyCode === 32) {
      this.props.onNodeToggle(this.props.id)
      e.preventDefault()
    }
  }

  render() {
    const { expanded, isLeaf, label,viewMode } = this.props
    const toggleCx = ['toggle'].filter(Boolean).join(' ')

    if (isLeaf) {
      return  <div/>
    }
    

    if(viewMode == 'full-mode'){
      return (<span role="button" style={{width:'12px',float:'left',position:'relative'}}
      tabIndex={-1}
      className={toggleCx}
      onClick={this.onToggle}
      onKeyDown={this.onKeyDown}
      aria-hidden
      classNamedd="mr-3">
      <img src={expanded?toAbsoluteUrl("/media/sr/icons/filter-minus.svg"):
      toAbsoluteUrl("/media/sr/icons/filter-plus.svg")} />
      </span>)
    }

    

    return (
      <div className="tree-view-expand-collapse" >
        <FiltersExpandCollapseButton
          label={label}
          isMenuExpanded={expanded}
          expandOrCollapseMenu={this.onToggle}
          transformLabel = {false}
        >
        <KeyboardArrowDown/> 
          </FiltersExpandCollapseButton>
      </div>
    );
  }
}

export default Toggle
